import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  standalone: false,
})
export class FaqComponent implements OnInit{
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;

  faq_content: string = 'linhas-faq-perguntas'

  faqReady: number = 0;
  faqInfo: any[] = [];
  faqInfoShow: any[] = [];

  faq_static_content: string = 'linhas-faq'
  faqStaticInfo: any = {};

  contacts_content: string = 'linhas-contacto';
  contactsInfo: any = {};

  searchParameter: string = '';
  searchForm: FormGroup = new FormGroup({
    text: new FormControl('')
  });

  constructor(
    private cmsService: CmsService,
    private translate: TranslateService,
    private router: Router,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['perguntasFrequentes']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit() {
    this.getFaq()
    this.getFooter()
  }

  getFaq(){

    this.cmsService.getContentList(this.faq_content, this.language).subscribe(
      {
        next: data => {
          this.faqInfo = data['body']['data'];

          this.faqInfo.sort((a,b) => (a.Ordem > b.Ordem) ? 1 : -1 );

          this.faqInfoShow = this.faqInfo;

          this.faqReady++

          this.onChanges()
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getFooter(){

    this.cmsService.getContentList(this.faq_static_content, this.language).subscribe(
      {
        next: data => {
          this.faqStaticInfo = data['body']['data']
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  onChanges(){
    this.searchForm.get('text')?.valueChanges.subscribe(
      val => {
        this.filterFaq(val.toLowerCase())
      }
    )
  }

  filterFaq(val: string){
    this.searchParameter = val;

    this.faqInfoShow = this.faqInfo
      .map(faq => ({
        ...faq,
        Perguntas: faq.Perguntas.filter((q: any) =>
          q.Pergunta.toLowerCase().includes(val) ||
          q.Resposta.toLowerCase().includes(val)
        )
      }))
      .filter(faq => faq.Perguntas.length > 0);
  }

  highlightText(text: string): string {
    if (!this.searchParameter) return text;

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const searchRegex = new RegExp(`(${this.searchParameter})`, 'gi');

    function highlightNodes(node: Node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const replaced = node.nodeValue?.replace(searchRegex, '<span class="highlight">$1</span>');
        if (replaced !== node.nodeValue) {
          const wrapper = document.createElement('span');
          wrapper.innerHTML = replaced || '';
          node.parentNode?.replaceChild(wrapper, node);
        }
      } else {
        node.childNodes.forEach(highlightNodes);
      }
    }

    highlightNodes(doc.body);

    return doc.body.innerHTML;
  }
}
